import React, { useEffect, useState } from 'react';
import Header from './app/layout/header';
import Menu from './app/layout/menu';
import Content from './app/layout/content';
import Footer from './app/layout/footer';
import './App.scss';
import './switcher.scss';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
 import ColorPicker from "./app/components/color-picker/color-picker";

// Security
import SignInSide from './app/components/security/login/signin';
import IdleTimerContainer from './app/components/idleTimerContainer';
import ProtectedRoute from '../src/app/components/security/protected.route';
import SecureComponent from '../src/app/components/security/secure.component'

import Head from './app/components/head/head';
import ErrorHandle from './app/components/error-handle/error-handle';

 


// import Reports from './app/components/reports/reports';
// import ExportSale from './app/components/reports/export-sale/export-sale';
// import Voucher from './app/components/reports/voucher/voucher';
// import InvoiceCosting from './app/components/reports/invoice-costing/invoice-costing';

import TreeViewSample from './app/components/chart-of-account/tree-view-sample';


import ReportsChangeAccess from './app/components/security/reports-change-access/reports-change-access';

import reportFormList from './app/components/reports/report-form-list';

function App() {
  console.log('App file Call')
  // const [ colorTheme, setColorTheme ] = useState('theme-white');

  // useEffect(() => {
  //   const currentThemeColor = localStorage.getItem('theme-color');
  //   if(currentThemeColor){
  //     setColorTheme(currentThemeColor);
  //   }
  // }, []);

  // const changeTheme =(theme) => {
  //   setColorTheme(theme);
  //   localStorage.setItem('theme-color', theme);
  // } 





  useEffect(() => {
    const handler = (e) => {
      if (e.isComposing) return;
  
      const el = e.target;
      if (!el) return;
  
      const tag = el.tagName;
      const isTextInput = tag === "INPUT" || tag === "TEXTAREA" || el.isContentEditable;
      if (!isTextInput) return;
  
      if (tag === "INPUT") {
        const type = (el.getAttribute("type") || "text").toLowerCase();
        if (["password", "file", "email"].includes(type)) return;
      }

      // Skip specific IDs or names 
      const id = el.getAttribute("id")?.toLowerCase(); 
      const name = el.getAttribute("name")?.toLowerCase(); 
      if (id === "username" || id === "password" || name === "username" || name === "password") { return; } 
  
      const current = typeof el.value === "string" ? el.value : (el.textContent ?? "");
      const upper = current.toUpperCase();
      if (upper === current) return;
  
      // mark to prevent re-entrancy storms
      if (el.dataset.__upperLock === "1") return;
      el.dataset.__upperLock = "1";
  
      try {
        if (typeof el.selectionStart === "number" && typeof el.selectionEnd === "number") {
          const s = el.selectionStart;
          const en = el.selectionEnd;
          el.value = upper;
          el.setSelectionRange(s, en);
        } else if (el.isContentEditable) {
          el.textContent = upper;
        } else {
          el.value = upper;
        }
  
        el.dispatchEvent(new Event("input", { bubbles: true }));
      } finally {
        // release lock next tick
        queueMicrotask(() => {
          delete el.dataset.__upperLock;
        });
      }
    };
  
    document.addEventListener("input", handler, true);
    return () => document.removeEventListener("input", handler, true);
  }, []);
  

  // irtiza test
  return (
    <div>
      {/* className={`App ${colorTheme}`} */}
      <div>
        <IdleTimerContainer
          extraTime={60 * 60 * 1000}
          standardTime={60 * 60 * 1000}
          // standardTime={30000}
        />
        
        <BrowserRouter>
          <Switch>
            <Route exact path='/' component={SignInSide} />
            <div className='content-box'>
              <ColorPicker />
              <Head />
              <Header />
              <Menu />
              {/* <ProtectedRoute exact path='/home' component={Content} /> */}
              <ProtectedRoute exact path='/home' component={SecureComponent} name='Dashboard' />

  <ProtectedRoute    exact  path='/reportForm' component={reportFormList} name='Yarn Count Information'  />

{/* SETUP Invoice INPUTS START */}
      <ProtectedRoute    exact  path='/setup/SaleInvoice' component={SecureComponent} name='SaleInvoice'  />
      <ProtectedRoute    exact  path='/setup/PurchaseInvoice' component={SecureComponent} name='PurchaseInvoice'  />
      <ProtectedRoute    exact  path='/setup/UnitOfMeasurement' component={SecureComponent} name='Unit Of Measurement'  />
{/* SETUP Invoice INPUTS START */}


{/* SETUP MODULE INPUTS START */}
      <ProtectedRoute    exact  path='/setup/YarnCount' component={SecureComponent} name='Yarn Count Information'  />

      <ProtectedRoute    exact  path='/setup/YarnCount' component={SecureComponent} name='Yarn Count Information'  />
      <ProtectedRoute    exact  path='/setup/YarnQuality' component={SecureComponent} name='Yarn Quality Information'  />
      <ProtectedRoute    exact  path='/setup/YarnType' component={SecureComponent} name='Yarn Type Information'  />
      <ProtectedRoute    exact  path='/setup/YarnBrand' component={SecureComponent} name='Yarn Brand Information'  />
      <ProtectedRoute    exact  path='/Setup/FullYarnCountInfo' component={SecureComponent} name='Full Yarn Count Information'  />
      <ProtectedRoute    exact  path='/Setup/AccessoryInfo' component={SecureComponent} name='Accessory Information'  />
      <ProtectedRoute    exact  path='/Setup/BudgetItemInfo' component={SecureComponent} name='Budget Items Information'  />
      <ProtectedRoute    exact  path='/Setup/ProductInfo' component={SecureComponent} name='Product Information'  />

      <ProtectedRoute    exact  path='/setup/AccessoryType' component={SecureComponent} name='Accessory Type Information'  />

      <ProtectedRoute    exact  path='/setup/Country' component={SecureComponent} name='Country Information'  />
      <ProtectedRoute    exact  path='/setup/Port' component={SecureComponent} name='Port Information'  />
      <ProtectedRoute    exact  path='/setup/Currency' component={SecureComponent} name='Currency Information'  />
      <ProtectedRoute    exact  path='/setup/ShipmentTerms' component={SecureComponent} name='Shipment Terms Information'  />
      <ProtectedRoute    exact  path='/setup/Packing' component={SecureComponent} name='Packing Information'  />
      <ProtectedRoute    exact  path='/setup/ContractType' component={SecureComponent} name='Contract Type Information'  />
      <ProtectedRoute    exact  path='/setup/Color' component={SecureComponent} name='Color Information'  />
      <ProtectedRoute    exact  path='/setup/ProductSize' component={SecureComponent} name='Product Size Information'  />
      <ProtectedRoute    exact  path='/setup/Fancy' component={SecureComponent} name='Fancy Information'  />
      <ProtectedRoute    exact  path='/setup/Unit' component={SecureComponent} name='Unit Information'  />
      <ProtectedRoute    exact  path='/setup/DeliveryStatus' component={SecureComponent} name='Delivery Status Information'  />
      <ProtectedRoute    exact  path='/setup/Godown' component={SecureComponent} name='Godown Information'  />
      <ProtectedRoute    exact  path='/setup/Designation' component={SecureComponent} name='Designation Information'  />
      <ProtectedRoute    exact  path='/setup/Softness' component={SecureComponent} name='Softness Information'  />
      <ProtectedRoute    exact  path='/setup/DryProcess' component={SecureComponent} name='Dry Process Information'  />
      <ProtectedRoute    exact  path='/setup/Process' component={SecureComponent} name='Process Information'  />
      <ProtectedRoute    exact  path='/setup/ReProcess' component={SecureComponent} name='ReProcess Information'  />
      <ProtectedRoute    exact  path='/setup/ProcessDesc' component={SecureComponent} name='Process Description Information'  />
      <ProtectedRoute    exact  path='/setup/LoomType' component={SecureComponent} name='Loom Type Information'  />
      <ProtectedRoute    exact  path='/setup/SewingType' component={SecureComponent} name='Sewing Type Information'  />

      {/* // For Property Project */}
      <ProtectedRoute exact path='/setup/Property' component={SecureComponent} name='Property' />
      <ProtectedRoute exact path='/setup/PropertyUsageType' component={SecureComponent} name='Property Usage Type' />
      <ProtectedRoute exact path='/setup/Building' component={SecureComponent} name='Building' />
      <ProtectedRoute exact path='/setup/PropertyLocation' component={SecureComponent} name='Property Location' />
      <ProtectedRoute exact path='/setup/PropertyFloor' component={SecureComponent} name='Property Floor' />
      <ProtectedRoute exact path='/setup/PropertyUnitType' component={SecureComponent} name='Property Unit Type' />
      <ProtectedRoute exact path='/setup/CostCenter' component={SecureComponent} name='Cost Center' />
      <ProtectedRoute exact path='/setup/ProductCategory' component={SecureComponent} name='Product Category' />
      <ProtectedRoute exact path='/setup/Nationality' component={SecureComponent} name='Nationality' />
      <ProtectedRoute exact path='/setup/ModeOfPayment' component={SecureComponent} name='Mode Of Payment' />
      <ProtectedRoute exact  path='/FullProperty' component={SecureComponent} name='Full Property'  />
      <ProtectedRoute exact  path='/Product' component={SecureComponent} name='Product'  />
      <ProtectedRoute exact  path='/PropertyOwner' component={SecureComponent} name='Property Owner'  />
      <ProtectedRoute exact  path='/AdditionalPayment' component={SecureComponent} name='Additional Payment'  />
      <ProtectedRoute exact  path='/Company' component={SecureComponent} name='Company'  />
      <ProtectedRoute exact  path='/TenantContractFS' component={SecureComponent} name='Tenant Contract FS'  />
      <ProtectedRoute exact  path='/TenantContractPM' component={SecureComponent} name='Tenant Contract PM'  />
      <ProtectedRoute exact  path='/ChequeStatus' component={SecureComponent} name='Cheque Status'  />

      <ProtectedRoute exact  path='/SaleInvoice' component={SecureComponent} name='Sale Invoice'  />
      <ProtectedRoute exact  path='/SaleInvoiceSandbox' component={SecureComponent} name='Sale Invoice Sandbox'  />
      <ProtectedRoute exact  path='/SaleInvoicePosted' component={SecureComponent} name='Sale Invoice'  />
      
      <ProtectedRoute exact  path='/PurchaseInvoice' component={SecureComponent} name='Purchase Invoice'  />
      <ProtectedRoute exact  path='/IssueInvoice' component={SecureComponent} name='Issue Invoice'  />
<ProtectedRoute    exact  path='/ReceivableAccounts' component={SecureComponent} name='ReceivableAccountsList'  />
<ProtectedRoute    exact  path='/AgentAccounts' component={SecureComponent} name='AgentAccountsList'  />

{/* VOUCHER INPUT IN FINANCE MODULE START*/}
<ProtectedRoute    exact  path='/Voucher/RV/:listType' component={SecureComponent} name='Receipt Voucher'  />
      
      <ProtectedRoute    exact  path='/Voucher/PV/:listType' component={SecureComponent} name='Payment Voucher'  />
      
      <ProtectedRoute    exact  path='/Voucher/JV/:listType' component={SecureComponent} name='Journal Voucher'  />
{/* VOUCHER INPUT IN FINANCE MODULE END*/}


{/* SECUIRTY MODULE INPUTS START */}

      <ProtectedRoute exact  path='/UsersInfo' component={SecureComponent} name='User Information'  />
      {/* <ProtectedRoute exact  path='/UsersInfo/Active' component={SecureComponent} name='User'  /> */}
      {/* <ProtectedRoute exact  path='/UsersInfo/InActive' component={SecureComponent} name='User'  /> */}
      <ProtectedRoute exact path="/Security/ChangePassword" component={SecureComponent} name={"ChangePasswordList"} />
      <ProtectedRoute exact path='/Security/ChangeAccess' component={SecureComponent} name={"ChangeAccessList"}/>
      <ProtectedRoute exact path='/Security/ReportsChangeAccess' component={ReportsChangeAccess} />

{/* SECUIRTY MODULE INPUTS END */}

{/* EXPORT MODULE INPUTS END */}
      <ProtectedRoute exact path='/Export/ExportOrder/Replicate' component={SecureComponent} name={`Export Order - Replicate`} />
      <ProtectedRoute exact path='/Export/TNA' component={SecureComponent} name={`TNA`} />
      <ProtectedRoute exact path='/Export/Budgeting' component={SecureComponent} name={'Budgeting'} />
{/* EXPORT MODULE INPUTS END */}


{/* ACCESSORY MODULE INPUTS END */}
      <ProtectedRoute exact path='/Accessory/AccessoryOpening/Summary' component={SecureComponent} name={`Accessory Opening`} />
      <ProtectedRoute exact path='/Accessory/AccessoryOpening/Detail' component={SecureComponent} name={`Accessory Opening`} />
{/* ACCESSORY MODULE INPUTS END */}
















        
    {/* <ProtectedRoute exact  path='/Processing/IssueTransaction/Normal' component={SecureComponent} name='ProcessingFabricIssueNormalList'/>  */}
      
      <ProtectedRoute    exact  path='/CurrencyTransfer' component={SecureComponent} name='CurrencyTransferList'  />

      <ProtectedRoute    exact  path='/InvoiceEvaluation' component={SecureComponent}  name='InvoiceEvaluationList'/>

      {/* <ProtectedRoute    exact  path='/Invoice/Sale/:listType' component={SecureComponent}  name='SaleInvoiceList'/> */}

      {/* <ProtectedRoute    exact  path='/Invoice/Purchase/:listType' component={SecureComponent} name='PurchaseInvoiceList' /> */}

      <ProtectedRoute    exact  path='/ShopTransfer/:listType' component={SecureComponent}  name='ShopTransferList' />

      <ProtectedRoute    exact  path='/Voucher/CR/:listType' component={SecureComponent} name='ReceiptVoucherList'  />
      
      <ProtectedRoute    exact  path='/Voucher/CP/:listType' component={SecureComponent} name='PaymentVoucherList'  />
      
      <ProtectedRoute    exact  path='/Voucher/J/:listType' component={SecureComponent} name='JournalVoucherList'  />
      
      <ProtectedRoute    exact  path='/setup/AccountTransfer' component={SecureComponent} name='AccountTransferList'  />

      
      <ProtectedRoute    exact  path='/setup/BrandVendor' component={SecureComponent} name='BrandVendorList'  />
      
      {/* <ProtectedRoute    exact  path='/setup/UnitOfMeasurement' component={SecureComponent} name='UnitOfMeasurementList'  /> */}

      <ProtectedRoute    exact  path='/setup/Currency' component={SecureComponent} name='CurrencyList'  />

      <ProtectedRoute    exact  path='/setup/EvaluationRate' component={SecureComponent} name='EvaluationRateList'  />
      
      <ProtectedRoute    exact  path='/setup/Product' component={SecureComponent} name='ProductList'  />
      
      <ProtectedRoute    exact  path='/setup/ProductTransfer' component={SecureComponent} name='ProductTransferList'  />
      
      <ProtectedRoute    exact  path='/setup/Shop' component={SecureComponent} name='ShopList'  />
      
      <ProtectedRoute    exact  path='/setup/SystemLock' component={SecureComponent} name='SystemLockList'  />
      
      <ProtectedRoute    exact  path='/setup/Designation' component={SecureComponent} name='DesignationList'  />
      
      <ProtectedRoute    exact  path='/Users' component={SecureComponent} name='UsersList'  />
      
      <ProtectedRoute    exact  path='/ChartOfAccount' component={SecureComponent} name='ChartOfAccountList'  />
      

      
      
      <ProtectedRoute exact  path='/UserReplicate' component={SecureComponent} name='UserReplicateList' />
            
      
      {/* <ProtectedRoute    exact  path='/ExportSale' component={ExportSale}  /> */}
      <ProtectedRoute exact  path='/SendEmail' component={SecureComponent} name='SendEmailList' />

      {/* Report Section */}
      
      <ProtectedRoute    exact  path='/ExportToExcel' component={SecureComponent} name='ExportToExcelList'  />
      
      <ProtectedRoute    exact  path='/ChartOfAccount/Report' component={SecureComponent} name='ChartOfAccountReport'  />
      
      <ProtectedRoute    exact  path='/Test/Input' component={SecureComponent} name='TestInputList'  />
      <ProtectedRoute    exact  path='/TreeViewSample' component={TreeViewSample} name='TreeViewSample'  />


      <ProtectedRoute
  exact
  path='/ReportVoucherCP/:VoucherDate/:VoucherType/:MainVoucherID/:VoucherID/:AccountIDCashBank/:CurrencyID/:MainInvoiceID/:ShopID/:VoucherCategory/:AccountID/:VoucherDetailID'
  // component={Voucher}
  component={SecureComponent}
   name={"CashPaymentPreview"}
/>
      <ProtectedRoute
  exact
  path='/ReportVoucherCR/:VoucherDate/:VoucherType/:MainVoucherID/:VoucherID/:AccountIDCashBank/:CurrencyID/:MainInvoiceID/:ShopID/:VoucherCategory/:AccountID/:VoucherDetailID'
  // component={Voucher}
  component={SecureComponent}
   name={"CashReceiptPreview"}
/>
      <ProtectedRoute
  exact
  path='/ReportVoucherJ/:VoucherDate/:VoucherType/:MainVoucherID/:VoucherID/:AccountIDCashBank/:CurrencyID/:MainInvoiceID/:ShopID/:VoucherCategory/:AccountID/:VoucherDetailID'
  // component={Voucher}
  component={SecureComponent}
   name={"JournalVoucherPreview"}
/>
      <ProtectedRoute
  exact
  path='/ReportInventory/:MainInvoiceID/:FromDate/:ToDate/:BrandID/:ProductID/:ShopID'
  // component={Inventory}
 component={SecureComponent} name={"StockShopWise"}

/>
      <ProtectedRoute
  exact
  path='/StockReportWithValue/:MainInvoiceID/:FromDate/:ToDate/:BrandID/:ProductID/:ShopID/:Type'
  component={SecureComponent}
  name={'StockWithValue'}
/>
      <ProtectedRoute
  exact
  path='/StockReportWithOutValue/:MainInvoiceID/:FromDate/:ToDate/:BrandID/:ProductID/:ShopID/:Type'
  component={SecureComponent}
  name={'StockWithOutValue'}
/>
      <ProtectedRoute
  exact
  path='/ReportInvoiceCosting/:MainInvoiceID/:FromDate/:ToDate/:BrandID/:ProductID/:ShopID'
  component={SecureComponent}
  name={'InvoiceCosting'}
/>


<ProtectedRoute
exact 
path='/Reports'
// component={Reports}
/>
      
      
{/* REPORT  INPUTS END */}
<ProtectedRoute exact path='/Reports/Export' component={SecureComponent} name={'Reports - Export'} />


<ProtectedRoute exact path='/Seller' component={SecureComponent} name={'Seller'} />
<ProtectedRoute exact path='/Buyer' component={SecureComponent} name={'Buyer'} />
<ProtectedRoute exact path='/UploadDataByExcel' component={SecureComponent} name={'import data'} />

      
{/* REPORT  INPUTS END */}


<Route
  exact
  path='/ErrorHandle'
  component={ErrorHandle}
  // name={'InvoiceCosting'}
/>

















              
            </div>
          </Switch>
          <Footer />
        </BrowserRouter>
      </div>
    </div>

  );
}

export default App;
